/**
 * @auth 赖传峰
 * @date 2024/8/27
 * @desc 帮助中心并未支持界面上的所有语言，如果界面语言没有被帮助中心支持，帮助中心使用默认语言英语
 */
import {
  useNuxtApp,
  useRuntimeConfig,
} from '#imports'
import { SupportLocale } from '~/types/enum'

export default (): SupportLocale => {
  const { public: { HELP_CENTER_LOCALES } } = useRuntimeConfig()
  const usrLocale = useNuxtApp().$i18n.locale.value
  return HELP_CENTER_LOCALES.includes(usrLocale) ? usrLocale : SupportLocale.EN_US
}
